// extracted by mini-css-extract-plugin
export default {"wrapper":"yC-z","button":"zC-z","alternate":"AC-z","disabled":"BC-z","paymentWarning":"CC-z","fadeIn":"DC-z"};